import { render, staticRenderFns } from "./McRead.vue?vue&type=template&id=15393e82&scoped=true&"
import script from "./McRead.vue?vue&type=script&lang=js&"
export * from "./McRead.vue?vue&type=script&lang=js&"
import style0 from "./McRead.vue?vue&type=style&index=0&id=15393e82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15393e82",
  null
  
)

export default component.exports